import { mountApplications } from '../../../wikis/show.js?vue3';
import { mountMoreActions } from '../../../wikis/more_actions.js?vue3';

mountApplications();
mountMoreActions();
